<!--课程资源-->
<template>
  <div class="xuexidongtai_layer">
    <div class="warp">
      <!-- 上 -->
      <div class="t-warp">
        <div class="l-img">
          <img src="~@imgs/curriculum/lefttop_bg.png" />
        </div>
        <div class="r-info">
          <div class="r-info-name">《AI金融课程》</div>
          <div class="r-info-class">典阅教育研究院</div>
          <el-progress :show-text="false" :stroke-width="10" :percentage="70" color="#73E4FD"
                       define-back-color="#E8F4FF"></el-progress>
          <div class="r-info-desc">共{{ chapterNum }}个章节</div>
          <div class="r-info-study" @click="$router.push('/curriculumStudy')">开始学习</div>
        </div>
      </div>

      <!-- 下 -->
      <div class="b-warp">
        <div class="b-left">
          <div class="tabs-control">
            <button class="tabs-item" :class="{ 'active': actived == 1 }" @click="actived = 1">介绍</button>
            <button class="tabs-item" :class="{ 'active': actived == 2 }" @click="actived = 2">目录</button>
          </div>
          <div class="tabs-content" :class="{ 'border-l': actived == 2 }">
            <!-- 1、介绍 -->
            <div class="introduce-view" v-show="actived == 1">
              <h2>适用人群：</h2>
              <p>本课程适用于金融科技、人工智能应用技术、大数据金融、互联网金融、经济学（金融方向）及相关专业的高职、本科层次应用型教学。</p>
              <br>
              <br>
              <h2>课程概述：</h2>
              <p>本课程培养掌握人工智能技术在金融领域的核心应用及智能体（Agent）搭建能力的高素质技能人才，具体达到以下要求：</p>
              <br>
              <p>具体达到以下要求：</p>
              <p>1.掌握AI在金融领域的核心应用场景，包括智能投顾、风险管理、智能客服、信用评估、反欺诈等。</p>
              <p>2.熟练掌握机器学习、自然语言处理等 AI 核心技术的基本原理，能结合信贷审批、智能投顾等金融场景进行技术匹配与应用设计。</p>
              <p>3.具备金融数据清洗、特征工程及可视化能力，能够处理结构化与非结构化金融数据（如新闻舆情、财报文本等）。</p>
              <p>4.熟悉金融智能体（Agent）的架构与开发，掌握强化学习在自动化交易、投资决策等场景的应用。</p>
              <p>5.理解智能金融体的架构设计逻辑，掌握智能客服、智能投研等典型智能金融应用的搭建流程，能独立完成简单智能金融模块的开发与调试。</p>
              <p>6.熟悉金融监管政策对 AI 应用的规范要求，具备识别和防范 AI 在金融应用中可能产生的伦理风险、数据安全风险的能力。</p>
              <p>7.掌握金融风控模型的构建与优化，能够运用AI技术识别市场风险和信用风险。</p>
              <p>8.能够运用 AI 技术对金融市场趋势、客户需求进行分析预测，提出创新性的金融产品或服务优化方案。</p>
              <p>9.具备团队协作能力，能在跨专业项目中（如与软件开发、金融业务团队合作）承担 AI 金融应用模块的设计与实施任务。</p>
              <p>10.了解AI技术在金融领域的前沿发展动态，具有持续学习和适应行业变化的能力。</p>
            </div>

            <!-- 2、目录 -->
            <div class="listings-view" v-show="actived == 2">
              <dl class="item" v-for="(item, index) in dataList" :key="index">
                <div class="dot"></div>
                <dt>{{ item.chapterName }}</dt>
                <dd v-for="(o, i) in item.sectionList" :key="i">
                  <!-- <el-tag v-if="o.coursewareType == 'pdf'" effect="plain" size="small" type="success">PPT</el-tag>
                  <el-tag v-else effect="plain" size="small">视频</el-tag> -->
                  <span v-if="o.coursewareType == 'pdf'" style="color:#624BF5;">PDF</span>
                  <span v-else style="color:#33A2F6;">视频</span>
                  <span style="margin: 0 5px;"
                        :style="{ color: (o.coursewareType == 'pdf') ? '#624BF5' : '#33A2F6' }">|</span>
                  <img style="margin:0 5px;"
                       :src="o.coursewareType == 'pdf' ? require('@imgs/curriculum/pdf.png') : require('@imgs/curriculum/video.png')" />
                  <span class="name-inner" @click="handleJump(item, o)">{{ o.sectionName }}</span>
                  <img class="complete" v-if="o.statue" src="~@imgs/curriculum/complete.png" />
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import apiCurriculum from '@/api/apiCurriculum.js'
export default {
  data () {
    return {
      actived: 1,
      dataList: [], //课程资源列表
      chapterNum: 0, //课程共多少章
      ChapterId: '', //章
      SectionId: '', //节
      resourcesID: ''//资源
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getCurriculum()
  },
  mounted () {
  },
  methods: {
    //获取课程资源数据
    getCurriculum () {
      this.dataList = [
        {
          "chapterId": "9250fac0-fa27-4c4b-9c4c-c7707c983969",
          "chapterName": "第一章 AI金融基础入门",
          "sectionList": [
            {
              "sectionId": "8af71dff-f977-4be4-adca-1e15aacec220",
              "sectionName": "第一节 金融行业数字化转型浪潮",
              "coursewareType": "pdf",
              "is_Read": 0
            },
            {
              "sectionId": "d124f725-560d-4613-b516-7881370d888f",
              "sectionName": "第二节 AI技术核心概念剖析",
              "coursewareType": "pdf",
              "is_Read": 0
            },
            {
              "sectionId": "d124f725-560d-4613-b516-7881370d888d",
              "sectionName": "第三节 AI金融的发展历程与现状综述",
              "coursewareType": "pdf",
              "is_Read": 0
            }
          ]
        },
      ]

      this.chapterNum = this.dataList.length
      // apiCurriculum.GetCurriculumList().then(res => {
      //   if (res) {
      //     this.dataList = res || []
      //     this.chapterNum = res.length || 0
      //     // localStorage.setItem('kechengdata', JSON.stringify(this.dataList))
      //   }
      // })
    },

    handleJump (item, o) {
      this.chapterId = item.chapterId
      this.SectionId = o.sectionId
      this.resourcesID = o.sectionId
      this.$router.push({
        path: '/curriculumStudy',
        query: {
          'ChapterId': this.chapterId,
          'SectionId': this.SectionId,
          'resourcesID': this.resourcesID
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.xuexidongtai_layer {
  padding: 20px 50px;
  height: calc(100% - 40px);

  .warp {
    display: flex;
    flex-wrap: wrap;

    .t-warp {
      width: 100%;
      display: flex;
      padding: 10px 30px 10px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 9px;

      .l-img img {
        display: block;
        // width: 496px;
        // height: 256px;
        width: 423px;
        height: 238px;
      }

      .r-info {
        flex: 1;
        color: #666666;
        margin-left: 50px;

        .r-info-name {
          font-size: 22px;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 20px;
          line-height: 30px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin-left: -10px;
          color: #434343;
        }

        .r-info-class {
          height: 60px;
          font-size: 16px;
          line-height: 20px;
          // margin-bottom: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          color: #666;
        }

        .r-info-desc {
          margin-top: 10px;
          text-indent: 10px;
        }

        .r-info-study {
          width: 139px;
          height: 40px;
          line-height: 40px;
          background: linear-gradient(90deg, #76E8FE 0%, #2187EC 100%);
          border-radius: 9px;
          color: #fff;
          font-weight: bold;
          text-align: center;
          margin-top: 20px;
          cursor: pointer;

          &:hover {
            filter: hue-rotate(20deg) brightness(100%);
          }
        }
      }
    }

    .b-warp {
      width: 100%;
      // padding: 30px 10px;
      display: flex;
      margin-top: 10px;

      .b-left {
        width: calc(100% - 60px);
        padding: 30px;
        background-color: #fff;
        border-radius: 9px;

        .tabs-control {
          display: flex;
          margin-bottom: 20px;

          .tabs-item {
            width: 190px;
            height: 38px;
            background: linear-gradient(123deg, #E7EFFB 0%, #F5F9FE 100%);
            color: #000000;
            font-size: 16px;
            text-align: center;
            border-radius: 8px;
            margin-right: 20px;
            cursor: pointer;
            box-shadow: 0 0 4px -2px rgba(0, 0, 0, 0.1);

            &.active {
              background: #1E84EC;
              color: #fff;
            }
          }
        }

        .border-l {
          border-left: 1px dashed #1E84EC;
        }

        .tabs-content {
          padding-left: 5px;

          // 1、介绍
          .introduce-view {
            h2 {
              color: #1E84EC;
              font-size: 17px;
              font-weight: bold;
              margin-bottom: 10px;
            }

            p {
              color: #333;
              font-size: 16px;
              line-height: 1.3;
            }
          }

          // 2、目录
          .listings-view {
            .item {
              margin-bottom: 30px;
              padding-left: 15px;
              position: relative;

              .dot {
                position: absolute;
                top: 20px;
                left: -10px;
                width: 10px;
                height: 10px;
                background-color: #1E84EC;
                border-radius: 50%;
                animation: waifaguang 3s ease-in-out forwards;
              }

              @keyframes waifaguang {
                0% {
                  box-shadow: none;
                }

                100% {
                  box-shadow: 0px 0px 10px #1E84EC;
                }
              }

              dt {
                color: #000000;
                font-size: 17px;
                font-weight: bold;
                margin-bottom: 20px;
                background: #E8F4FF;
                border-radius: 23px;
                padding: 15px 30px;
              }

              dd {
                margin-bottom: 15px;
                padding-left: 5px;
                font-size: 16px;
                white-space: nowrap;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: flex;
                align-items: center;

                .name-inner {
                  cursor: pointer;

                  &:hover {
                    color: #006eff;
                  }
                }

                .complete {
                  position: absolute;
                  right: 15px;
                }

              }
            }
          }
        }
      }

    }
  }
}
</style>
